import { useEffect, useState } from 'react';
import { SectionWrapper } from '../../../../components/ui/SectionWrapper';
import { useLanguage } from '../../../../context/LanguageContext';
import { Education } from '../../../../models/education.interface';
import { educationService } from '../../../../services/education.service';

export function EducationSection() {
    const { lang, t } = useLanguage();
    const [education, setEducation] = useState<Education[]>([]);

    useEffect(() => {
        setEducation(educationService.getEducation());
    }, []);

    return (
        <SectionWrapper id="education" title={t('section.education')} alternate>
            <div className="space-y-6">
                {education.map(edu => (
                    <div key={edu.id} className="bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm ring-1 ring-slate-900/5 dark:ring-slate-700/50">
                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-2">
                            <h3 className="text-lg font-semibold text-slate-900 dark:text-white">
                                {edu.degree[lang]}
                            </h3>
                            <span className="text-sm text-slate-500 dark:text-slate-400 font-mono">
                                {edu.start_year} - {edu.end_year || t('label.present')}
                            </span>
                        </div>

                        <p className="text-blue-600 dark:text-blue-400 font-medium text-sm mb-1">
                            {edu.institution}
                        </p>

                        <p className="text-sm text-slate-500 dark:text-slate-400 mb-2">
                            <i className="bi bi-geo-alt mr-1" />{edu.location}
                        </p>

                        {edu.gpa && (
                            <p className="text-sm text-slate-600 dark:text-slate-300">
                                <span className="font-medium">{t('label.gpa')}:</span> {edu.gpa}
                            </p>
                        )}

                        {edu.description && (
                            <p className="text-sm text-slate-600 dark:text-slate-300 mt-1">
                                {edu.description[lang]}
                                {edu.url && (
                                    <a href={edu.url} target="_blank" rel="noreferrer noopener" className="ml-2 text-blue-600 dark:text-blue-400 hover:underline">
                                        <i className="bi bi-box-arrow-up-right" />
                                    </a>
                                )}
                            </p>
                        )}

                        {edu.type === 'exchange' && (
                            <span className="inline-block mt-2 text-xs font-medium px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300">
                                {lang === 'en' ? 'Exchange' : 'Intercambio'}
                            </span>
                        )}
                    </div>
                ))}
            </div>
        </SectionWrapper>
    );
}
